"use strict";
/**
 * TO UPDATE:
 * 1. Find all places that are "MODIFIED", move them into the new built index.ts (in .graphclient)
 * 2. add these comments (including eslint disables)
 * 3. move the modified index file to quick-sync/graphql/
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable import/newline-after-import */
/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/no-unsafe-return */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.PoiMessageHashesDocument = exports.getBuiltGraphSDK = exports.subscribe = exports.execute = exports.getBuiltGraphClient = exports.createBuiltMeshHTTPHandler = exports.getMeshOptions = exports.rawServeConfig = void 0;
const utils_1 = require("@graphql-mesh/utils");
const utils_2 = require("@graphql-mesh/utils");
const utils_3 = require("@graphql-mesh/utils");
const cache_localforage_1 = __importDefault(require("@graphql-mesh/cache-localforage"));
const fetch_1 = require("@whatwg-node/fetch");
const graphql_1 = __importDefault(require("@graphql-mesh/graphql"));
const merger_stitching_1 = __importDefault(require("@graphql-mesh/merger-stitching"));
const utils_4 = require("@graphql-mesh/utils");
const http_1 = require("@graphql-mesh/http");
const runtime_1 = require("@graphql-mesh/runtime");
const store_1 = require("@graphql-mesh/store");
const cross_helpers_1 = require("@graphql-mesh/cross-helpers");
const baseDir = cross_helpers_1.path.join(typeof __dirname === 'string' ? __dirname : '/', '..');
const importFn = (moduleId) => {
    const relativeModuleId = (cross_helpers_1.path.isAbsolute(moduleId)
        ? cross_helpers_1.path.relative(baseDir, moduleId)
        : moduleId)
        .split('\\')
        .join('/')
        .replace(baseDir + '/', '');
    switch (relativeModuleId) {
        case '.graphclient/sources/txs-ethereum/introspectionSchema':
            return Promise.resolve().then(() => __importStar(require('./.graphclient/sources/txs-ethereum/introspectionSchema')));
        case '.graphclient/sources/txs-goerli/introspectionSchema':
            return Promise.resolve().then(() => __importStar(require('./.graphclient/sources/txs-goerli/introspectionSchema')));
        default:
            return Promise.reject(new Error(`Cannot find module '${relativeModuleId}'.`));
    }
};
const rootStore = new store_1.MeshStore('.graphclient', new store_1.FsStoreStorageAdapter({
    cwd: baseDir,
    importFn,
    fileType: 'ts',
}), {
    readonly: true,
    validate: false,
});
exports.rawServeConfig = undefined;
async function getMeshOptions() {
    const pubsub = new utils_2.PubSub();
    const sourcesStore = rootStore.child('sources');
    const logger = new utils_3.DefaultLogger('GraphClient');
    const cache = new cache_localforage_1.default({
        ...{},
        importFn,
        store: rootStore.child('cache'),
        pubsub,
        logger,
    });
    const sources = [];
    const transforms = [];
    const additionalEnvelopPlugins = [];
    const txsEthereumTransforms = [];
    const txsGoerliTransforms = [];
    const additionalTypeDefs = [];
    const txsEthereumHandler = new graphql_1.default({
        name: 'txs-ethereum',
        config: {
            endpoint: 'https://api.thegraph.com/subgraphs/name/ekrembal/railgun-transactions-ethereum',
        },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child('txs-ethereum'),
        logger: logger.child('txs-ethereum'),
        importFn,
    });
    const txsGoerliHandler = new graphql_1.default({
        name: 'txs-goerli',
        config: {
            endpoint: 'https://api.thegraph.com/subgraphs/name/ekrembal/railgun-transactions-goerli',
        },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child('txs-goerli'),
        logger: logger.child('txs-goerli'),
        importFn,
    });
    sources[0] = {
        name: 'txs-ethereum',
        handler: txsEthereumHandler,
        transforms: txsEthereumTransforms,
    };
    sources[1] = {
        name: 'txs-goerli',
        handler: txsGoerliHandler,
        transforms: txsGoerliTransforms,
    };
    const additionalResolvers = [];
    const merger = new merger_stitching_1.default({
        cache,
        pubsub,
        logger: logger.child('stitchingMerger'),
        store: rootStore.child('stitchingMerger'),
    });
    return {
        sources,
        transforms,
        additionalTypeDefs,
        additionalResolvers,
        cache,
        pubsub,
        merger,
        logger,
        additionalEnvelopPlugins,
        get documents() {
            return [
                {
                    document: exports.PoiMessageHashesDocument,
                    get rawSDL() {
                        return (0, utils_4.printWithCache)(exports.PoiMessageHashesDocument);
                    },
                    location: 'PoiMessageHashesDocument.graphql',
                },
            ];
        },
        fetchFn: fetch_1.fetch,
    };
}
exports.getMeshOptions = getMeshOptions;
function createBuiltMeshHTTPHandler() {
    return (0, http_1.createMeshHTTPHandler)({
        baseDir,
        getBuiltMesh: getBuiltGraphClient,
        rawServeConfig: undefined,
    });
}
exports.createBuiltMeshHTTPHandler = createBuiltMeshHTTPHandler;
let meshInstance$;
function getBuiltGraphClient() {
    if (meshInstance$ == null) {
        meshInstance$ = getMeshOptions()
            .then(meshOptions => (0, runtime_1.getMesh)(meshOptions))
            .then(mesh => {
            const id = mesh.pubsub.subscribe('destroy', () => {
                meshInstance$ = undefined;
                mesh.pubsub.unsubscribe(id);
            });
            return mesh;
        });
    }
    return meshInstance$;
}
exports.getBuiltGraphClient = getBuiltGraphClient;
const execute = (...args) => getBuiltGraphClient().then(({ execute }) => execute(...args));
exports.execute = execute;
const subscribe = (...args) => getBuiltGraphClient().then(({ subscribe }) => subscribe(...args));
exports.subscribe = subscribe;
function getBuiltGraphSDK(globalContext) {
    const sdkRequester$ = getBuiltGraphClient().then(({ sdkRequesterFactory }) => sdkRequesterFactory(globalContext));
    return getSdk((...args) => sdkRequester$.then(sdkRequester => sdkRequester(...args)));
}
exports.getBuiltGraphSDK = getBuiltGraphSDK;
exports.PoiMessageHashesDocument = (0, utils_1.gql) `
  query PoiMessageHashes($idLow: Bytes = "0x00") {
    transactionInterfaces(orderBy: id, first: 1000, where: { id_gt: $idLow }) {
      id
      nullifiers
      commitments
      transactionHash
      boundParamsHash
      blockNumber
    }
  }
`;
function getSdk(requester) {
    return {
        PoiMessageHashes(variables, options) {
            return requester(exports.PoiMessageHashesDocument, variables, options);
        },
    };
}
exports.getSdk = getSdk;
